'use strict';

/**
 *
 * @name: CategoryAnalyticsFactory
 *
 */

function CategoryAnalyticsFactory($analytics, $rootScope, $location) {

  'ngInject';

  function followCategory(category) {

    var properties = {
      eventAction: 'Category: ' + category.translations[$rootScope.lang].slug,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Follow', properties);
  }

  function unfollowCategory(category) {

    var properties = {
      eventAction: 'Category: ' + category.translations[$rootScope.lang].slug,
      eventPoints: 0,
      attributes: {
        label: $location.path()
      }
    };

    return $analytics.eventTrack('Unfollow', properties);
  }

  return {
    followCategory: followCategory,
    unfollowCategory: unfollowCategory
  };
}

export default CategoryAnalyticsFactory;



// WEBPACK FOOTER //
// ./app/pages/category/category-analytics.factory.js